import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-description-modal-ras',
  templateUrl: './description-modal-ras.component.html',
  styleUrls: ['./description-modal-ras.component.scss'],
})
export class DescriptionModalRasComponent implements OnInit {
  constructor(
    dialogRef: MatDialogRef<DescriptionModalRasComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  get title() {
    return this.data.title;
  }

  get description() {
    return this.data.description;
  }
  ngOnInit() {}
}
